import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-navigation-layout',
  templateUrl: './navigation-layout.component.html',
})
export class NavigationLayoutComponent implements OnInit {
  ngOnInit(): void {}
}
